import LocalStorageService from "services/LocalStorageService";
import {PAGE_URLS} from "constants/AppConstants";
import {isAndroid} from "FirebaseUtils";
import {CONNECT_SERVICES, getPendingMobileConnect} from "utils/mobileConnectService";

// When the OAuth flow was started from the mobile connect page, the provider callback
// must be routed back to it (success screen + app deep link) instead of My Account
const getMobileConnectPathname = (service: string): string | null => {
  return getPendingMobileConnect() === service ? PAGE_URLS.connectServicePageUrl : null;
};

export const handleGP3Service = (history: any): boolean => {
  // Get params activityId from localStorage and code from url then redirect to activity page
  const urlParams = new URLSearchParams(window.location.search);
  const activityId = LocalStorageService.get("activityId");
  LocalStorageService.remove("activityId");

  const code = urlParams.get("code");
  const state = urlParams.get("state");
  const isNotGP3S = state === "coros" || state === "suunto" || state === "strava";
  if (isNotGP3S) {
    return true;
  }

  const mobileConnectPathname = code && getMobileConnectPathname(CONNECT_SERVICES.gpsspeedsurfing);
  if (mobileConnectPathname) {
    history.push({
      pathname: mobileConnectPathname,
      state: {gpsSpeedsurfingToken: code}
    });
    return false;
  }

  if ((isAndroid || activityId) && code) {
    history.push({
      pathname: isAndroid ? PAGE_URLS.androidSettingsPageUrl : `${PAGE_URLS.activityPageUrl}/${activityId}`,
      state: {gpsSpeedsurfingToken: code}
    });
    return false;
  } else if (code) {
    history.push({
      pathname: isAndroid ? PAGE_URLS.androidSettingsPageUrl : PAGE_URLS.myAccountPageUrl,
      state: {gpsSpeedsurfingToken: code}
    });
    return false;
  }
  return true;
};

export const handleGarminService = (history: any): boolean => {
  const urlParams = new URLSearchParams(window.location.search);
  const oauthToken = urlParams.get("oauth_token");
  const oauthVerifier = urlParams.get("oauth_verifier") === "null" ? null : urlParams.get("oauth_verifier");
  if (oauthToken) {
    history.push({
      pathname:
        getMobileConnectPathname(CONNECT_SERVICES.garmin) ||
        `${isAndroid ? PAGE_URLS.androidSettingsPageUrl : PAGE_URLS.myAccountPageUrl}`,
      state: {garminOauthToken: oauthToken, garminOauthVerifier: oauthVerifier}
    });
    return false;
  }
  return true;
};

export const handleSuuntoService = (history: any): boolean => {
  const urlParams = new URLSearchParams(window.location.search);
  const suuntoAuthorizationCode = urlParams.get("code");
  const isSuunto = urlParams.get("state") === "suunto";
  if (suuntoAuthorizationCode && isSuunto) {
    history.push({
      pathname:
        getMobileConnectPathname(CONNECT_SERVICES.suunto) ||
        `${isAndroid ? PAGE_URLS.androidSettingsPageUrl : PAGE_URLS.myAccountPageUrl}`,
      state: {suuntoAuthorizationCode, isSuunto}
    });
    return false;
  }
  return true;
};

export const handleCorosService = (history: any): boolean => {
  const urlParams = new URLSearchParams(window.location.search);
  const corosAuthorizationCode = urlParams.get("code");
  const isCoros = urlParams.get("state") === "coros";
  if (corosAuthorizationCode && isCoros) {
    history.push({
      pathname:
        getMobileConnectPathname(CONNECT_SERVICES.coros) ||
        `${isAndroid ? PAGE_URLS.androidSettingsPageUrl : PAGE_URLS.myAccountPageUrl}`,
      state: {corosAuthorizationCode, isCoros}
    });
    return false;
  }
  return true;
};

export const handleStravaService = (history: any): boolean => {
  const urlParams = new URLSearchParams(window.location.search);
  const stravaAuthorizationCode = urlParams.get("code");
  // Strava reports the scopes the athlete actually granted here, not in the token exchange.
  const stravaScope = urlParams.get("scope");
  const isStrava = urlParams.get("state") === "strava";
  if (stravaAuthorizationCode && isStrava) {
    history.push({
      pathname:
        getMobileConnectPathname(CONNECT_SERVICES.strava) ||
        `${isAndroid ? PAGE_URLS.androidSettingsPageUrl : PAGE_URLS.myAccountPageUrl}`,
      state: {stravaAuthorizationCode, stravaScope, isStrava}
    });
    return false;
  }
  return true;
};
